import gql from 'graphql-tag';
const HEAR_IT_TYPE_IT_ACTIVITY_FRAGMENT = gql `
  fragment HearItTypeItActivityFragment on HearItTypeItActivity {
    rounds {
      id
      roundIndex
      type
      audio
      optionalImage: image
      attempts
      instructions
      instructionsAudio
      steps {
        stepIndex
        answer
      }
    }
  }
`;
export default HEAR_IT_TYPE_IT_ACTIVITY_FRAGMENT;
